<template lang="html">
  <div id="campo" class="container-fluid">
    <div id="formulario-top">
      <div class="row">
        <div class="col-md-2 col-md-offset-2 col-xs-10 col-xs-offset-1">
          <select-c name="ducto" id="ducto-campo" :options="ductos" placeholder="DUCTO" @changeSelect="ductosEvent($event)"></select-c>
        </div>
        <!--  <div id="input-check" class="col-md-3 col-md-offset-0 col-sm-6 col-xs-10 col-xs-offset-1">
          <input id="check" type="checkbox">
          <label for="check" class="text-uppercase"> todas las estaciones</label>
        </div>
       <div class="buttons col-md-4 col-md-offset-0 col-sm-5 col-sm-offset-4 col-xs-12 col-xs-offset-1">
          <button class="btn btn-default text-uppercase waves-effect waves-light">limpiar</button>
          <button class="btn btn-default text-uppercase waves-effect waves-light">guardar</button>
        </div> -->
      </div>
    </div>

    <div id="tabla" class="row">
      <c-table id="campo-dd" :data="data" :names="bitacoraNames" @mapMarker="changeMarkers($event)" modalTarget="#campo-dd-modal"
        height="height: 35vh;" tbClass="striped">
      </c-table>
    </div>

    <br>
    <br>

    <div id="form-bot" class="row">
      <div class="col-md-2 col-md-offset-3 col-xs-10 col-xs-offset-1">
        <select-c name="ducto2" id="ducto2" :options="ductos" placeholder="DUCTO" @changeSelect="batId = $event"></select-c>
      </div>
      <div class="col-md-2 col-md-offset-0 col-xs-10 col-xs-offset-1">
        <date-picker :date="date" :option="option" @change="fecha = $event"></date-picker>
      </div>
      <div class="buttons col-md-4 col-md-offset-0 col-xs-10 col-xs-offset-1">
        <button class="btn btn-default text-uppercase waves-effect waves-light" @click="bateriaEvent($event)" :class="[batId === '' ? 'disabled' : '']">buscar</button>
        <a href="" >
          <!-- DOWNLOAD BUTTON
          // IF YOU WANT TO DO IT IN CSV ADD
          type="csv"
          AND CHANGE .xls TO .csv -->
          <json-ex
            :data   = "jsonData"
            :fields = "jsonFields"
            :name    = "`CAMP-BATERIA-${fecha}.xls`"
            :meta   = "jsonMeta">
            <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
          </json-ex>
        </a>
      </div>
    </div>

    <div class="row tabla-bottom">
      <div class="col-md-12 col-sm-12">
        <single-table id="campo-single" :data="baterias" :names="camposBotNames" @mapMarker="changeMarkers($event)" modalTarget="#campo-single-modal"
          height="height: 25vh;"></single-table>
      </div>
    </div>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <modal name="loading-modal" cclass="transparent">
      <loading-modal :info="{ modalName: 'loading-modal' }"></loading-modal>
    </modal>
  </div>
</template>

<script>
  import JsonEx from 'vue-json-excel'
  import selectC from 'reusable/Select'
  import cInput from 'reusable/Input'
  import cTable from 'reusable/DropDownTable'
  import singleTable from 'components/Campo/CampoTable'
  import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  let Modal = () => import('reusable/Modal')
  let LoadingModal = () => import('components/Modals/LoginModal')
  import toastr from 'toastr'

  export default {
    data() {
      return {
        jsonData: [],
        jsonFields: {},
        jsonMeta: [{'key' : 'charset', 'value' : 'utf-8'}],
        date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsFecha,
        fecha: '',
        ductos: '',
        data: [],
        batId: '',
        baterias: [],
        bitacoraNames: {
          'f1': {
            name: 'Estación',
            // icon: 'fa-angle-down'
          },
          'f2': {
            name: 'Antena',
          },
          'f3': {
            name: 'Fecha',
          },
          'f4': {
            name: 'Retardo',
          },
          'f5': {
            name: 'Presión A',
          },
          'f6': {
            name: 'Sensibilidad',
          },
          'f7': {
            name: 'Factor',
          },
          'f9': {
            name: 'Batería',
          },
          'f10': {
            name: 'USB Libre',
          },
          'f11': {
            name: 'Señal',
          },
          'f15': {
            name: 'Rango PIT',
          },
        },
        camposBotNames: {
          'c1': {
            name: 'Ducto'
          },
          'c2': {
            name: 'Estación'
          },
          'c3': {
            name: '00:00'
          },
          'c4': {
            name: '01:00'
          },
          'c5': {
            name: '02:00'
          },
          'c6': {
            name: '03:00'
          },
          'c7': {
            name: '04:00'
          },
          'c8': {
            name: '05:00'
          },
          'c9': {
            name: '06:00'
          },
          'c10': {
            name: '07:00'
          },
          'c11': {
            name: '08:00'
          },
          'c12': {
            name: '09:00'
          },
          'c13': {
            name: '10:00'
          },
          'c14': {
            name: '11:00'
          },
          'c15': {
            name: '12:00'
          },
          'c16': {
            name: '13:00'
          },
          'c17': {
            name: '14:00'
          },
          'c18': {
            name: '15:00'
          },
          'c19': {
            name: '16:00'
          },
          'c20': {
            name: '17:00'
          },
          'c21': {
            name: '18:00'
          },
          'c22': {
            name: '19:00'
          },
          'c23': {
            name: '20:00'
          },
          'c24': {
            name: '21:00'
          },
          'c125': {
            name: '22:00'
          },
          'c26': {
            name: '23:00'
          },
        },
      }
    },
    mounted() {
      this.$store.dispatch('LOAD_OPS')
        .then(resp => {
          this.ductos = this.$store.getters.GET_OP({
            filteredBy: 'section_name'
          })
        })
        // DOWNLOADING FILE TO EXCEL ---- FILLING FIELDS
        Object.keys(this.camposBotNames).forEach((f, k) => {
          if(this.camposBotNames[f].name !== 'Ducto' || this.camposBotNames[f].name !== 'Estación') {
            this.jsonFields[k] = this.camposBotNames[f].name
          }
          if(Object.keys(this.camposBotNames).length === k + 1) {
            this.jsonFields[k + 2] = 'Ducto'
            this.jsonFields[k + 3] = 'Estación'
          }
        })
    },
    watch: {
      baterias() { // DOWNLOADING FILE TO EXCEL ---- FILLING DATA
        this.baterias.forEach((f, key) => {
          Object.keys(f).forEach((item, k) => {
            if(!this.jsonData[key]){
              this.jsonData[key] = {}
              this.jsonData[key][0] = f['ducto']
              this.jsonData[key][1] = f['estacion']
            }
            if(item === 'ducto' || item === 'estacion') {
              return
            }
            if(item.split('')[0] === '0') {
              this.jsonData[key][String(Number(item.split('')[1]) + 2)] = f[String(item)] || 0
            } else {
              this.jsonData[key][String(Number(item) + 2)] = f[String(item)] || 0
            }
          })
        })
      }
    },
    methods: {
      csvExport() {
        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent += JSON.stringify(this.jsonData)
        window.open(encodeURI(csvContent))
      },
      loading() {
        document.querySelector('#loading-btn').click()
      },
      formatDate(date){
        if (date === '') {
          date = new Date().toLocaleString('es-US', {
            hour12: false
          }).split(' ')
        }

        let time = date[1]
        let mdy = date[0].split('/')
        let month = parseInt(mdy[0])
        let day = parseInt(mdy[1])
        let year = parseInt(mdy[2])
        return `${year}-${day}-${month} ${time}`
      },
      bateriaEvent(e){
        if(this.batId === '') {
          return
        }
        this.loading()
        let hasta = null
        let d = document.querySelector(`#${this.batId}`).value
        if(this.fecha === '') {
          this.fecha = new Date(new Date().setHours(0, 0, 0)).toLocaleString('es-US', { hour12: false }).split(' ')
          this.fecha = this.formatDate(this.fecha)
          hasta = new Date().toLocaleString('es-US', { hour12: false }).split(' ')
          hasta = this.formatDate(hasta)
        } else {
          let temp = this.fecha
          temp = temp.split('-')
          temp[2] = temp[2].split(' ')[0]
          hasta = `${temp[0]}-${temp[1]}-${temp[2]} 23:59`
        }

        this.$store.dispatch('LOAD_BATERIA', {
          estacion: '',
          ducto: d,
          desde: this.fecha,
          hasta
        })
          .then(resp => {
            if(resp.data.length === 0){
              toastr.error('No se encontró información')
              this.loading()
              return
            }
            this.loading()
            let arr = {}
            let temp = []
            let firstMin = []

          /* ---- GET todos los minutos de cada hora ---- */
            resp.data.forEach(r => {
              let time = r.formated_date.split(' ')[1].split(':')
              if(!temp[`'${time[0]}'`]) {
                temp[`'${time[0]}'`] = []
                temp[`'${time[0]}'`].push(time[1])
              } else {
                temp[`'${time[0]}'`].push(time[1])
              }
            })
          /* ---- Filtrar primer minuto de cada hora ---- */
            Object.keys(temp).map((t, i) => {
              let min = Array.from(new Set(temp[t]))
              firstMin.push(min[min.length - 1])
            })
            temp = []
          /* ---- Agregar en un Arreglo los arreglos que sean el primer minuto de la hora ---- */
            resp.data.forEach((r, i) => {
              for (let index = 0; index < 24; index++) {
                let time = r.formated_date.split(' ')[1].split(':')
                if(Number(time[0]) === Number(index) && time[1] === firstMin[index]) {
                    temp.push(r)
                }
              }
            })
          /* ---- Revertir el arreglo para sacar las horas por ductos ---- */
            temp.reverse().forEach(z => {
              let hExists = 0
              if(!arr[z.rtu_name]) {
                arr[z.rtu_name] = []
                arr[z.rtu_name].push(z)
              } else {
                arr[z.rtu_name].forEach(a => {
                  let aH = a.formated_date.split(' ')[1].split(':')[0]
                  let zH = z.formated_date.split(' ')[1].split(':')[0]

                  if(Number(aH) === Number(zH)){
                    hExists++
                  }
                })
                if(hExists === 0) {
                  arr[z.rtu_name].push(z)
                }
              }
            })
          /* ---- Acomodar el arreglo para mostrar en pantalla ---- */
            Object.keys(arr).map((k, i) => {
              this.baterias.push({
                ducto: arr[k][0].section_name,
                estacion: arr[k][0].rtu_name,
              })
              arr[k].forEach((a, index) => {
                  this.baterias[i][a.formated_date.split(' ')[1].split(':')[0]] = a.battery
              })
            })
          })
          .catch(err => {
            console.log('Error', err)
          })
      },
      ductosEvent(e) {
        this.loading()
        let d = document.querySelector(`#${e}`)
        this.$store.dispatch('LOAD_ESTADOS', {
          estado: 1
        })
          .then(resp => {
            if(resp.data.length === 0){
              toastr.error('No se encontró información')
              this.loading()
              return
            }
            this.loading()
            let data = resp.data.filter(ducto => d.value === ducto.id_section)
            data.forEach(dat => {
              this.data.push({
                estacion: dat.id_section,
                site: dat.site_name,
                antena: dat.antena || 0,
                fecha: new Date(Number(dat.gps_timestamp)).toLocaleString('es-US', { hour12: false }) || null,
                retardo: dat.retardo || 0,
                presion: dat.pressure || 0,
                sensibilidad: dat.sesns || 0,
                factor: dat.factor || 0,
                bateria: dat.battery || 0,
                usb: dat.usb || 0,
                senal: dat.senal || 0,
                pit: dat.pit || 0
              })
            })
          })
          .catch(err => {
            console.log('error', err)
          })
      }
    },
    components: {
      selectC,
      cInput,
      cTable,
      singleTable,
      datePicker,
      Modal,
      LoadingModal,
      JsonEx
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';

  .col-md-12,
  .col-sm-12 {
    margin: 0;
    padding: 0;
  }

  .container-fluid,
  .row {
    margin: 0;
    padding: 0;
  }

  #form-bot {
    margin-bottom: 25px;
  }

  #campo {
    background-color: $bg;
    #formulario-top {
      height: 15vh;
      margin-top: 80px;
      border-bottom: 1px solid $inactive;
      @include tablet {
        height: 30vh;
      }
    }

    .buttons {
      @include tablet {
        margin-top: 25px;
      }
    }

    #input-check {
      text-align: center;
      input {
        padding: 5px;
      }
      label {
        font-size: 16px;
        padding-left: 10px;
      }
      @include tablet {
        // width: 35%;
        input {
          margin-top: 20px;
        }
        label {}
      }
    }

    .btn-default {
      margin-top: 0;
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
    }
  }
.tabla-bottom{
  height:100vh;
}
  .sub-table {
    &:nth-child(odd) {
      background-color: white !important;
    }

    &:nth-child(even) {
      background-color: $bg !important;
    }
  }
#loading-modal-modal {
      background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Campo.vue?33c5b2dc